export const ethnicGroups = {
  0: 'White',
  1: 'Asian',
  2: 'Coloured',
  3: 'Black',
};
